import { getService } from 'reducers/service';
import ServiceName from '../../shared/constants/serviceName';

export const getEvidenceCheckoutRequests = async (clearanceLevel) => {
  const service = getService(ServiceName.rms_evidence_checkout_request);

  const response = await service.find({
    query: {
      IsDeleted: false,
      action: 'All-checkout-requests',
      clearanceLevel,
      $sort: {
        Created: -1,
      },
    },
  });

  return response?.data || response || [];
};

export const getMyCheckoutRequests = async () => {
  const service = getService(ServiceName.rms_evidence_checkout_request);

  const response = await service.find({
    query: { action: 'my-checkout-requests' },
  });

  return response?.data || response || [];
};

// Same scope as getMyCheckoutRequests but includes Completed/Canceled requests too — used by
// the portal's "Past Requests" table. getMyCheckoutRequests (used by My Dashboard) is untouched.
export const getMyCheckoutRequestsAll = async () => {
  const service = getService(ServiceName.rms_evidence_checkout_request);

  const response = await service.find({
    query: { action: 'my-checkout-requests-all' },
  });

  return response?.data || response || [];
};
